import Typography from "#/components/shared/typography";
import { MessageTemplateListItem } from "#/services/messageTemplates";
import MessageTemplateRow from "#/message-templates/components/MessageTemplateRow";

type MessageTemplatesTableProps = {
  items: MessageTemplateListItem[];
  contextKey: string;
};

export function MessageTemplatesTable({
  items,
  contextKey,
}: MessageTemplatesTableProps) {
  return (
    <div className="overflow-x-auto rounded-xl border border-beige-200 bg-white">
      <table className="min-w-full text-left text-sm">
        <thead className="bg-cream-50 text-brown-700">
          <tr>
            <th className="px-4 py-3 font-semibold">Name</th>
            <th className="px-4 py-3 font-semibold">Status</th>
            <th className="px-4 py-3 font-semibold">Updated</th>
            <th className="px-4 py-3 font-semibold">Preview</th>
            <th className="px-4 py-3 font-semibold">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-beige-100">
          {items.map((item) => (
            <MessageTemplateRow
              key={item.id}
              item={item}
              contextKey={contextKey}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function MessageTemplatesEmptyState() {
  return (
    <div className="rounded-xl border border-dashed border-beige-200 bg-white p-8 text-center">
      <Typography variant="h4" className="text-brown-700">
        No message templates found.
      </Typography>
    </div>
  );
}

export default MessageTemplatesTable;
